import { getListTransform } from 'helpers/transformResponse';
import types from './types';

const INITIAL_STATE = {
  list: { content: [] },
  detail: {},
  loading: false,
  buttonLoading: false,
  status: 'idle',
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.REFERRAL_CAMPAIGNS_FETCHED:
      return {
        ...state,
        list: getListTransform(action.payload.data) || INITIAL_STATE.list,
        loading: false,
      };
    case types.REFERRAL_CAMPAIGN_DETAIL:
      return {
        ...state,
        detail: action.payload,
        loading: false,
        status: 'resolved',
      };
    case types.REFERRAL_CAMPAIGN_LOAD:
      return {
        ...state,
        loading: action.payload,
        status: action.payload,
      };
    case types.REFERRAL_CAMPAIGN_BUTTON_LOAD:
      return {
        ...state,
        buttonLoading: action.payload,
      };
    default:
      return state;
  }
};
